module.exports = __webpack_public_path__ + "img/robot-land.4450f32b.png";